import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';

const OptionalRedirectUrlSchema = z.preprocess(
  value => value === '' ? undefined : value,
  z.string().url().optional(),
);

export const BannerDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string().optional(),
  description: z.string().optional(),

  isActive: z.boolean(),
  isDefault: z.boolean(),
  isPublic: z.boolean(),

  presentation: z.object({
    order: z.number().optional(),
    redirectUrl: OptionalRedirectUrlSchema,
  }).nullish(),

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),

  assets: z.array(z.object({
    appearance: z.enum(['default', 'tablet', 'mobile', 'desktop']),
  }).merge(MediaDtoSchema)).nullable(),

  expiresAt: z.string().optional(),
}).describe('BannerDtoSchema');

export type BannerDtoType = z.infer<typeof BannerDtoSchema>;
